import { createApi } from '@reduxjs/toolkit/query/react';
import { JimboResponse } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const signupEmailApi = createApi({
  reducerPath: 'signupEmailApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['signup-email'],
  endpoints: (builder) => ({
    sendEmailInvite: builder.mutation({
      query: (customerData) => {
        return {
          url: 'signup/email',
          method: 'POST',
          body: customerData,
        };
      },
      transformResponse: (response: JimboResponse) => response,
      invalidatesTags: ['signup-email'],
    }),
  }),
});

export const { useSendEmailInviteMutation } = signupEmailApi;
